/**
 * Labstep
 *
 * @module core/GoogleDoc
 */

import type React from 'react';
import type { IGoogleDocProps } from './types';

export const GoogleDoc: React.FC<IGoogleDocProps> = ({ file }) => (
  <iframe
    title={file.name}
    src={file.path}
    style={{
      width: '100%',
      height: '100%',
      border: 'none',
    }}
  />
);
